<template>
  <div class="delete-account-page">
    <b-row class="justify-content-center">
      <b-col lg="8" md="10" sm="12">
        <b-card>
          <div class="text-center mb-2">
            <feather-icon
              icon="AlertTriangleIcon"
              size="64"
              class="text-danger"
            />
            <h2 class="mt-1 text-danger">مسح الحساب</h2>
          </div>

          <b-alert variant="danger" show class="mb-2">
            <div class="alert-body p-1">
              <h4 class="alert-heading text-danger mb-1">
                تحذير: هذا الإجراء لا يمكن التراجع عنه
              </h4>
              <ul class="mb-0">
                <li>سيتم حذف حسابك بشكل دائم.</li>
                <li>سيتم فقدان جميع بياناتك ولا يمكن استعادتها.</li>
                <li>لن تتمكن من الدخول إلى حسابك مرة أخرى.</li>
                <li>سيتم تسجيل خروجك تلقائياً عند تأكيد العملية.</li>
              </ul>
            </div>
          </b-alert>

          <b-form-group
            label="للتأكيد، اكتب كلمة (حذف) في الخانة التالية"
            label-for="confirm-text"
          >
            <b-form-input
              id="confirm-text"
              v-model="confirmText"
              placeholder="حذف"
              :disabled="loading"
            />
          </b-form-group>

          <div class="d-flex justify-content-between mt-2">
            <b-button
              variant="outline-secondary"
              :disabled="loading"
              @click="cancel"
            >
              إلغاء
            </b-button>
            <b-button
              variant="danger"
              :disabled="!canConfirm || loading"
              @click="confirmDelete"
            >
              <b-spinner v-if="loading" small class="mr-50" />
              تأكيد مسح الحساب
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import Swal from "sweetalert2";
import Auth from "@/Apis/Auth";
import UsersController from "@/Controllers/UsersController";

const usersController = new UsersController();

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BButton,
    BFormGroup,
    BFormInput,
    BSpinner,
  },
  data() {
    return {
      confirmText: "",
      loading: false,
    };
  },
  computed: {
    canConfirm() {
      return this.confirmText.trim() === "حذف";
    },
  },
  methods: {
    cancel() {
      this.$router.push({ name: "profile" });
    },
    async confirmDelete() {
      if (!this.canConfirm || this.loading) return;
      this.loading = true;
      try {
        const res = await usersController.deleteProfile();
        if (res && res.errorCode === 0) {
          await Swal.fire({
            icon: "success",
            title: "تم حذف الحساب",
            text: "تم حذف حسابك بنجاح",
            showConfirmButton: false,
            timer: 2000,
          });
          Auth.logOut();
        } else {
          Swal.fire({
            icon: "error",
            title: "تعذر حذف الحساب",
            text: (res && (res.errorDescription || (res.data && res.data.message))) || "حدث خطأ غير متوقع.",
          });
        }
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "تعذر حذف الحساب",
          text: "حدث خطأ غير متوقع.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.delete-account-page {
  padding: 1rem;
}
</style>
